import { IProfile } from '@jumpstart/core';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Link from '@mui/material/Link';
import React, { Fragment, useEffect, useState } from 'react';
import StripeCustomerJson from './action-views/StripeCustomerJson';
import { createStripeCustomer, ICreateCustomer } from './services/Customer';
import ActionDialogTitle from './widgets/ActionDialogTitle';

export interface IStripeCustomerLink {
  subscriberProfile: IProfile;
}

export default function StripeCustomerLink(props: IStripeCustomerLink) {
  const {subscriberProfile} = props;
  const [production] = useState(process.env.NODE_ENV === 'production');
  const [creating, setCreating] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState<null | string>(null);

  const handleCreateStripeProfile = (data: Omit<ICreateCustomer, 'production' | 'profileId'>) => {
    setOpen(false);
    if (creating) {
      return;
    }
    setCreating(true);
    createStripeCustomer({
      ...data,
      profileId: subscriberProfile.id
    })
      .then(({customer, status}) => {
        console.log('Created Customer Status:', status);
        setCreating(false);
        setId(customer.id);
      })
      .catch((err: Error) => {
        console.error('Failed to create customer', err);
      });
  }

  useEffect(() => {
    if (subscriberProfile.payment) {
      const customerIDKey = production ? 'stripeCustomerId' : 'stripeCustomerIdDev';
      if ((subscriberProfile.payment as any)[customerIDKey]) {
        setId((subscriberProfile.payment as any)[customerIDKey]);
      }
    } else {
      setId(null);
    }
  }, [subscriberProfile.payment]);

  return (
    <Fragment>
      {id ?
        <Link
          href={`https://dashboard.stripe.com/${production ? '' : 'test/'}customers/${id}`}
          target={'stripe_customer'}
        >
          {id}
        </Link>
        :
        <Link
          variant="body2"
          onClick={() => setOpen(true)}
        >
          Create Stripe Profile {creating && <CircularProgress size={16}/>}
        </Link>
      }

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
      >
        <ActionDialogTitle id="action-scheduled" onClose={() => setOpen(false)}>
          Create Stripe Account
        </ActionDialogTitle>
        <DialogContent>
          <StripeCustomerJson subscriberProfile={subscriberProfile} onSubmit={handleCreateStripeProfile}/>
        </DialogContent>
      </Dialog>
    </Fragment>
  )
}
